module.exports = "/images/lt-icon.svg?bdcbd6509b46da6f904325659358acec";


//////////////////
// WEBPACK FOOTER
// ./resources/images/speedtest-result/lt-icon.svg
// module id = OjJR
// module chunks = 7 182